// Danh sach logical key ma game M1 can (art brief docs/gdd/content-mvp.md muc 6 + orbs.md).
// Moi skin phai co du cac key nay; test va check:art doi chieu manifest voi danh sach nay.
import { COLORS } from '@ml/config';

export const ORB_COLORS = COLORS;
/** Kind orb thuong (orbs.md 2.2). `essence` co sprite rieng theo tier. */
export const ORB_KINDS = ['basic', 'kin', 'far', 'laneH', 'laneV', 'diag'] as const;
export const COLORED_BOOSTERS = ['rocketH', 'rocketV', 'bomb', 'propeller'] as const;
export const ESSENCE_TIERS = ['t1', 't2', 't3', 't4'] as const;
export const OVERLAYS = ['lock', 'freeze1', 'freeze2', 'freeze3', 'deadMark'] as const;
export const INTENT_ICONS = ['attack', 'multiAttack', 'lock', 'freeze', 'deadMark', 'destroy', 'heal'] as const;
export const VFX = ['flameCleave', 'tidalWard', 'eclipseBrand', 'prismFall', 'stun'] as const;
export const RARITIES = ['common', 'rare', 'epic', 'legendary'] as const;

export type CharAnim = 'idle' | 'attack' | 'cast' | 'hit' | 'death';

export interface CharacterArt {
  /** Khung goc (px art), vuong */
  size: 48 | 64 | 96;
  /** So frame moi anim (content-mvp 6.3); anim vang mat = khong co */
  anims: Partial<Record<CharAnim, number>>;
}

const HERO_ANIMS = { idle: 4, attack: 4, cast: 4, hit: 2, death: 4 } as const;
const MONSTER_ANIMS = { idle: 4, attack: 4, hit: 2, death: 4 } as const;
const ELITE_ANIMS = { idle: 4, attack: 4, cast: 4, hit: 2, death: 4 } as const;
const BOSS_ANIMS = { idle: 4, attack: 4, cast: 4, hit: 2, death: 6 } as const;

/** artKey -> khung + anim. Moi artKey trong packages/content phai co o day (test kiem). */
export const CHARACTER_ART: Record<string, CharacterArt> = {
  'hero.aria': { size: 48, anims: HERO_ANIMS },
  'monster.mossSlime': { size: 48, anims: MONSTER_ANIMS },
  'monster.cinderImp': { size: 48, anims: MONSTER_ANIMS },
  'monster.frostWarden': { size: 64, anims: ELITE_ANIMS },
  'monster.hollowLich': { size: 96, anims: BOSS_ANIMS },
};

export const ANIM_FPS: Record<CharAnim, number> = { idle: 6, attack: 10, cast: 10, hit: 8, death: 8 };

export const BUFF_IDS = [
  'sharpEdge',
  'runeFocus',
  'ironHeart',
  'emberTide',
  'tideCall',
  'duskVeil',
  'warcry',
  'sealGuard',
  'surge',
  'deepEssence',
  'archmage',
  'overflow',
] as const;

export const BG_KEYS = [
  'bg.sunkenCrypt.far',
  'bg.sunkenCrypt.floor',
  'bg.sunkenCrypt.ceilFill',
  'bg.sunkenCrypt.boardPanel',
  'bg.sunkenCrypt.torch',
  'bg.sunkenCrypt.pillar',
  'bg.sunkenCrypt.grave',
  'bg.sunkenCrypt.chain',
] as const;

export const UI_KEYS = ['shadow.small', 'shadow.large', 'ui.targetArrow', ...Array.from({ length: 10 }, (_, i) => `ui.digit.${i}`)];

/** Toan bo logical key bat buoc cua mot skin M1. */
export function requiredKeys(): string[] {
  const keys: string[] = [];
  for (const c of ORB_COLORS) for (const k of ORB_KINDS) keys.push(`orb.${c}.${k}`);
  for (const b of COLORED_BOOSTERS) for (const c of ORB_COLORS) keys.push(`booster.${b}.${c}`);
  keys.push('booster.lightball');
  for (const t of ESSENCE_TIERS) keys.push(`essence.${t}`);
  for (const o of OVERLAYS) keys.push(`overlay.${o}`);
  for (const [artKey, art] of Object.entries(CHARACTER_ART))
    for (const anim of Object.keys(art.anims)) keys.push(`${artKey}.${anim}`);
  for (const i of INTENT_ICONS) keys.push(`intent.${i}`);
  for (const v of VFX) keys.push(`vfx.${v}`);
  for (const b of BUFF_IDS) keys.push(`buff.${b}`);
  for (const r of RARITIES) keys.push(`ui.buffFrame.${r}`);
  keys.push(...BG_KEYS, ...UI_KEYS);
  return keys;
}
